import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when the element changes. Replaces inline
// onchange="…" handlers, which the content security policy forbids.
//
//   <select data-controller="autosubmit" data-action="change->autosubmit#submit">
export default class extends Controller {
  submit() {
    this.element.form?.requestSubmit()
  }
}
